<template>
  <b-navbar class="col-md-3 d-md-block" toggleable="md">
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <h6 class="m-5 border-bottom"><i class="fa-solid fa-newspaper"></i> Παλαιότερες Εκδόσεις</h6>
    <b-collapse is-nav id="nav_collapse" class="nav flex-column my-1">
      <!-- Decade Navigation Links -->
      <b-nav-item class="p-2">
        <i class="fa-regular fa-calendar-days"></i><router-link to="/1980" exact class="my-3 p-2" id="nav1"> Δεκαετία 1980</router-link>
      </b-nav-item>
      <b-nav-item class="p-2">
        <i class="fa-regular fa-calendar-days"></i><router-link to="/1990" exact class="my-3 p-2" id="nav1"> Δεκαετία 1990</router-link>
      </b-nav-item>
      <b-nav-item class="p-2">
        <i class="fa-regular fa-calendar-days"></i><router-link to="/2000" exact class="my-3 p-2" id="nav1"> Δεκαετία 2000</router-link>
      </b-nav-item>
      <b-nav-item class="p-2">
        <i class="fa-regular fa-calendar-days"></i><router-link to="/2010" exact class="my-3 p-2" id="nav2"> Δεκαετία 2010</router-link>
      </b-nav-item>
      <b-nav-item class="p-2">
        <i class="fa-regular fa-calendar-days"></i><router-link to="/2020" exact class="my-3 p-2" id="nav3"> Δεκαετία 2020</router-link>
      </b-nav-item>
      <h6 class="m-5 border-bottom"><i class="fa-solid fa-book-open"></i><router-link to="/books"> Κιμωλιακή Βιβλιοθήκη</router-link></h6>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
.text-white {
  padding: 30px;
}

h6 {
  color: white;
  font-family: Arial, serif;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  text-shadow: -0.5px 0 #3d647f, 0 0.5px #2b6caf, 0.5px 0 #9fb3d6, 0 -0.5px #abe8ff;

}

.navbar {
  font-family: Arial, serif;
  background: rgb(95, 171, 241);
  /* For browsers that do not support gradients */
  background: -webkit-linear-gradient(rgb(93, 139, 236), rgb(95, 171, 241), #30bee9);
  /* For Safari 5.1 to 6.0 */
  background: -o-linear-gradient(rgb(93, 139, 236), rgb(95, 171, 241), #30bee9);
  /* For Opera 11.1 to 12.0 */
  background: -moz-linear-gradient(rgb(93, 139, 236), rgb(95, 171, 241), #30bee9);
  /* For Firefox 3.6 to 15 */
  background: linear-gradient(rgb(93, 139, 236), rgb(95, 171, 241), #30bee9);
}

.navbar-toggler {
  background-color: rgb(218, 231, 239);
}

.col-md-3 {
  border-right: 1px solid rgb(194, 192, 192);
}

.nav-link {
  text-align: center;
  color: white;
}

a {
  color: white;
}

.router-link-active {

  color: #0a4975;
  font-weight: bold;
}

.navbar.col-md-3.d-md-block.navbar-light.navbar-expand-md {
  padding: 0;
}

li {
  width: 100%;
  border-top: 1px solid rgb(194, 192, 192);
  border-bottom: 1px solid rgb(194, 192, 192);
  border-radius: 3px;
  text-align: left;

}

li:hover {
  background-color: rgba(255, 255, 255, 0.2);
  border-left: 5px solid white;
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/sideMenu.vue